import { isEmpty } from 'lodash-es';

import { useSecurityAuditReportSecretsList } from '../../hooks/useSecurityAuditReportSecretsList';
import { SecretsListContainer } from '../SecretsListContainer';
import { SecurityAuditListEmpty } from '../SecurityAuditListEmpty';
import { SecurityAuditReportSecretsList } from '../SecurityAuditReportSecretsList';

export const SecurityAuditReportSecrets = () => {
    const data = useSecurityAuditReportSecretsList();

    return (
        <SecretsListContainer isEmpty={isEmpty(data)} empty={<SecurityAuditListEmpty messageId='securityAudit.report.empty' />}>
            {({ height, width }) => <SecurityAuditReportSecretsList data={data} height={height ?? 600} width={width ?? 800} />}
        </SecretsListContainer>
    );
};
